import styled from "styled-components";
import { flexCenter } from "../mixins";

const SituationsContainer = styled.div`
    width: 100%;
    ${flexCenter};
    flex-wrap: wrap;
`;

export default SituationsContainer;
